module.exports = __webpack_public_path__ + "img/线下海量@2x.f616c008.png";